/**
 * Skye Profile Modal Component
 * Shows Skye's profile information when avatar is clicked
 */
import React from 'react';
import { X, Sparkles, Cloud, Plane, MessageCircle } from 'lucide-react';

const SkyeProfileModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div 
        className="relative max-w-lg w-full bg-gradient-to-br from-slate-900 via-slate-800 to-sky-900 rounded-2xl overflow-hidden shadow-2xl border border-sky-500/30"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 p-2 bg-black/50 hover:bg-black/70 rounded-full text-white transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
        
        {/* Profile image */}
        <div className="relative">
          <img 
            src="/skye.png" 
            alt="Skye" 
            className="w-full h-auto object-cover"
          />
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-slate-900 to-transparent p-6">
            <h2 className="text-3xl font-bold text-white mb-1">Skye</h2>
            <p className="text-sky-300 text-lg">Your Personal Butler</p>
          </div>
        </div>
        
        {/* Profile info */}
        <div className="p-6 space-y-4">
          <div className="flex items-center gap-3 text-slate-300">
            <Sparkles className="w-5 h-5 text-sky-400" />
            <span>AI-powered assistant for NSAS crew</span>
          </div>
          <div className="flex items-center gap-3 text-slate-300">
            <Cloud className="w-5 h-5 text-sky-400" />
            <span>Weather briefings & METAR/TAF analysis</span>
          </div>
          <div className="flex items-center gap-3 text-slate-300">
            <Plane className="w-5 h-5 text-sky-400" />
            <span>Flight schedules & crew information</span>
          </div>
          <div className="flex items-center gap-3 text-slate-300">
            <MessageCircle className="w-5 h-5 text-sky-400" />
            <span>Always here to help, 24/7</span>
          </div>
          
          <div className="pt-4 border-t border-slate-700">
            <p className="text-sm text-slate-400 italic text-center">
              "Whatever you need, I'm here for you! 💋"
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkyeProfileModal;
